import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search, Camera } from "lucide-react";

// Barra de busca + botão "escanear" dentro do banner de Conferência de Carga
// (fev/2026). Enter (ou clique no ícone) dispara `onSubmit(text)` no
// MobileEntregador, que faz o match flexível e o POST /confirmar-recebimento.
export function ConferenciaSearchBar({ onSubmit, onOpenScanner, disabled }) {
  const [text, setText] = useState("");

  const submit = () => {
    const t = String(text || "").trim();
    if (!t) return;
    onSubmit?.(t);
    setText("");
  };

  return (
    <div className="flex items-stretch gap-2" data-testid="conferencia-search-bar">
      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-violet-500 pointer-events-none" />
        <Input
          type="text"
          inputMode="numeric"
          autoComplete="off"
          placeholder="Número do pedido…"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submit();
            }
          }}
          disabled={disabled}
          className="pl-8 h-11 border-violet-300 focus-visible:ring-violet-500 bg-white"
          data-testid="conferencia-search-input"
        />
      </div>
      <Button
        type="button"
        onClick={submit}
        disabled={disabled || !text.trim()}
        className="h-11 px-3 bg-violet-700 hover:bg-violet-800 text-white"
        data-testid="btn-conferencia-search-submit"
        title="Confirmar por número do pedido"
      >
        <Search className="w-4 h-4" />
      </Button>
      <Button
        type="button"
        onClick={onOpenScanner}
        disabled={disabled}
        className="h-11 px-3 bg-violet-900 hover:bg-violet-950 text-white shadow-md"
        data-testid="btn-conferencia-open-scanner"
        title="Escanear código de barras"
      >
        <Camera className="w-4 h-4 mr-1" />
        Scanner
      </Button>
    </div>
  );
}
